import React, { useState } from 'react';

type Prop = {
    id: number; title: string; location: string; price: string;
    beds: number; baths: number; area: string; type: 'rent' | 'sale'; tag?: string;
};

const PROPERTIES: Prop[] = [
    { id:1,  title:'Luxury Penthouse',       location:'Dubai Marina',        price:'AED 45,000 / mo', beds:4, baths:4, area:'4,200 sqft', type:'rent', tag:'Featured' },
    { id:2,  title:'Modern Villa',           location:'Palm Jumeirah',       price:'AED 28,000 / mo', beds:5, baths:6, area:'6,800 sqft', type:'rent' },
    { id:3,  title:'Executive Apartment',    location:'Downtown Dubai',      price:'AED 12,500 / mo', beds:2, baths:2, area:'1,650 sqft', type:'rent' },
    { id:4,  title:'Waterfront Residence',   location:'JBR',                 price:'AED 18,000 / mo', beds:3, baths:3, area:'2,400 sqft', type:'rent' },
    { id:5,  title:'Studio Retreat',         location:'Dubai Silicon Oasis', price:'AED 5,500 / mo',  beds:0, baths:1, area:'580 sqft',   type:'rent' },
    { id:6,  title:'Corporate Villa',        location:'Jumeirah',            price:'AED 35,000 / mo', beds:5, baths:5, area:'7,200 sqft', type:'rent' },
    { id:7,  title:'Signature Villa',        location:'Emirates Hills',      price:'AED 22,000,000',  beds:6, baths:7, area:'9,500 sqft', type:'sale', tag:'Prime' },
    { id:8,  title:'Sky Collection Unit',    location:'Dubai Creek Harbour', price:'AED 3,800,000',   beds:2, baths:2, area:'1,900 sqft', type:'sale' },
    { id:9,  title:'Golf Community Villa',   location:'Arabian Ranches',     price:'AED 8,500,000',   beds:4, baths:5, area:'5,100 sqft', type:'sale' },
    { id:10, title:'Ultra-Luxury Penthouse', location:"One Za'abeel",        price:'AED 35,000,000',  beds:5, baths:5, area:'8,200 sqft', type:'sale', tag:'Rare' },
    { id:11, title:'Waterfront Apartment',   location:'Dubai Marina',        price:'AED 2,900,000',   beds:1, baths:2, area:'980 sqft',   type:'sale' },
    { id:12, title:'Panoramic Tower Suite',  location:'Business Bay',        price:'AED 4,200,000',   beds:2, baths:2, area:'1,400 sqft', type:'sale' },
];

/* defaultTab prop — passed from App.tsx for /rent and /sale routes */
interface PropertiesProps {
    defaultTab?: 'rent' | 'sale';
}

const Properties: React.FC<PropertiesProps> = ({ defaultTab = 'sale' }) => {
    const [tab, setTab] = useState<'rent' | 'sale'>(defaultTab);
    const list = PROPERTIES.filter(p => p.type === tab);

    return (
        <>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&display=swap');

        .pr-section {
          background: var(--bg);
          padding: 7rem 0;
          position: relative;
          transition: background 0.4s;
        }
        .pr-section::before {
          content: ''; position: absolute; top: 0; left: 0; right: 0; height: 1px;
          background: linear-gradient(90deg, transparent, var(--border-t), transparent);
        }
        .pr-inner { max-width: 1280px; margin: 0 auto; padding: 0 5rem; }
        .pr-head {
          display: flex; align-items: flex-end;
          justify-content: space-between;
          margin-bottom: 3.5rem;
          flex-wrap: wrap; gap: 1.5rem;
        }
        .pr-tabs {
          display: flex;
          border: 1.5px solid var(--border-t);
          border-radius: var(--r);
          overflow: hidden;
        }
        .pr-tab {
          font-family: var(--ff-ui);
          font-size: 0.7rem; font-weight: 600;
          letter-spacing: 0.16em; text-transform: uppercase;
          padding: 10px 26px;
          cursor: pointer; background: transparent; color: var(--ink2);
          transition: background 0.3s, color 0.3s;
        }
        .pr-tab.on { background: var(--teal); color: #fff; }
        .pr-tab:not(.on):hover { color: var(--teal); background: var(--teal-pale); }
        .pr-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1px;
          background: var(--border);
        }
        .pr-card {
          background: var(--surface);
          padding: 2.6rem 2.4rem;
          position: relative; cursor: default;
          transition: background 0.3s;
        }
        .pr-card:hover { background: var(--surface2); }
        .pr-card::after {
          content: ''; position: absolute; bottom: 0; left: 0;
          width: 0; height: 2px; background: var(--gold);
          transition: width 0.45s var(--ease);
        }
        .pr-card:hover::after { width: 100%; }
        .pr-badge {
          display: inline-block;
          font-family: var(--ff-ui);
          font-size: 0.62rem; font-weight: 600;
          letter-spacing: 0.18em; text-transform: uppercase;
          background: var(--gold); color: var(--navy);
          padding: 4px 12px; border-radius: var(--r);
          margin-bottom: 1rem;
        }
        .pr-spacer { height: 26px; }
        .pr-title {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: 1.75rem; font-weight: 500;
          color: var(--ink); margin-bottom: 6px;
          line-height: 1.2; transition: color 0.3s;
          letter-spacing: 0.01em;
        }
        .pr-card:hover .pr-title { color: var(--teal); }
        .pr-loc {
          font-family: var(--ff-ui);
          font-size: 0.7rem; font-weight: 500;
          letter-spacing: 0.12em; text-transform: uppercase;
          color: var(--ink3); margin-bottom: 1.4rem;
          display: flex; align-items: center; gap: 0.4rem;
        }
        .pr-loc::before { content: '●'; color: var(--teal); font-size: 0.5rem; }
        .pr-div { height: 1px; background: var(--border); margin-bottom: 1.3rem; }
        .pr-price {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: 1.55rem; font-weight: 600;
          color: var(--teal); margin-bottom: 1rem;
          letter-spacing: 0.01em;
        }
        .pr-meta { display: flex; gap: 2rem; flex-wrap: wrap; }
        .pr-mi {
          font-family: var(--ff-b);
          font-size: 0.8rem; font-weight: 400;
          letter-spacing: 0.05em; text-transform: uppercase;
          color: var(--ink3);
        }
        .pr-mv { color: var(--ink); font-weight: 600; }
        .pr-arr {
          position: absolute; top: 1.8rem; right: 1.8rem;
          font-size: 1rem; color: var(--border2);
          transition: color 0.3s, transform 0.3s;
        }
        .pr-card:hover .pr-arr { color: var(--gold); transform: translate(2px, -2px); }

        @media (max-width: 900px) {
          .pr-inner  { padding: 0 2rem; }
          .pr-grid   { grid-template-columns: 1fr; }
          .pr-head   { flex-direction: column; align-items: flex-start; }
          .pr-title  { font-size: 1.55rem; }
          .pr-price  { font-size: 1.4rem; }
        }
        @media (max-width: 500px) {
          .pr-title { font-size: 1.4rem; }
          .pr-mi    { font-size: 0.75rem; }
        }
      `}</style>

            <section className="pr-section">
                <div className="pr-inner">
                    <div className="pr-head">
                        <div>
                            <p className="sec-label">Portfolio</p>
                            <h2 className="sec-h2">
                                {tab === 'sale'
                                    ? <>Properties for <em>Sale</em></>
                                    : <>Properties for <em>Rent</em></>}
                            </h2>
                        </div>
                        <div className="pr-tabs">
                            <button
                                className={`pr-tab${tab === 'sale' ? ' on' : ''}`}
                                onClick={() => setTab('sale')}
                            >
                                For Sale
                            </button>
                            <button
                                className={`pr-tab${tab === 'rent' ? ' on' : ''}`}
                                onClick={() => setTab('rent')}
                            >
                                For Rent
                            </button>
                        </div>
                    </div>

                    <div className="pr-grid">
                        {list.map(p => (
                            <div key={p.id} className="pr-card">
                                {p.tag
                                    ? <span className="pr-badge">{p.tag}</span>
                                    : <div className="pr-spacer" />
                                }
                                <h3 className="pr-title">{p.title}</h3>
                                <p className="pr-loc">{p.location}</p>
                                <div className="pr-div" />
                                <p className="pr-price">{p.price}</p>
                                <div className="pr-meta">
                  <span className="pr-mi">
                    Beds <span className="pr-mv">{p.beds === 0 ? 'Studio' : p.beds}</span>
                  </span>
                                    <span className="pr-mi">
                    Baths <span className="pr-mv">{p.baths}</span>
                  </span>
                                    <span className="pr-mi">
                    Area <span className="pr-mv">{p.area}</span>
                  </span>
                                </div>
                                <span className="pr-arr">↗</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Properties;